module.exports = __webpack_public_path__ + "img/download-tile-bg-desktop_jp.bb79951.jpg";